import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CompassIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Compass",
    children: [/*#__PURE__*/_jsx("path", {
      d: "m22.346 8.12-9.143 4.572c-.22.112-.4.29-.511.511l-4.571 9.143A1.14 1.14 0 0 0 9.143 24c.174 0 .348-.04.511-.12l9.143-4.572c.22-.112.4-.29.511-.511l4.571-9.143a1.14 1.14 0 0 0-.214-1.32 1.15 1.15 0 0 0-1.319-.213M16 18.287c-1.261 0-2.286-1.025-2.286-2.286S14.74 13.714 16 13.714 18.286 14.74 18.286 16 17.26 18.286 16 18.286"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16 0C7.177 0 0 7.177 0 16s7.177 16 16 16 16-7.177 16-16S24.823 0 16 0m0 29.714C8.438 29.714 2.286 23.563 2.286 16 2.286 8.438 8.438 2.286 16 2.286S29.714 8.438 29.714 16 23.563 29.714 16 29.714"
    })]
  }));
};
CompassIcon.displayName = 'CompassIcon';